import { takeEvery, call } from 'redux-saga/effects';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../shared/api/headers';
import { RECOVER_PASSWORD_URL, DEFAULT_BASE_URL } from '../../shared/api/urls';
import { apiRequest } from '../../shared/api';
import { RECOVER_PASSWORD } from '../../actions/actionTypes';

function* getPassworRecoveryAsync(action) {
    const { email } = action;
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: RECOVER_PASSWORD_URL,
        params: {
            Email: email,
        },
    };

    try {
        yield call(apiRequest, requestConfig);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchPasswordRecovery() {
    yield takeEvery(RECOVER_PASSWORD, getPassworRecoveryAsync);
}
